import React from 'react';
import Notification from './Notification';

const variantlist = [
    'success',
    'danger',
    'warning',
    'info',
]


function renderNotificationList(notifications, removeNotification) {
    return notifications.map((item, i) => {
        const variant = variantlist[i % variantlist.length];
        return <Notification
            key={i}
            item={item}
            variant={variant}
            hotel_name={item.hotel.name}
            tour_name={item.tour.name}
            onRemoveNotification={removeNotification}
        />
    });
}


class NotificationList extends React.Component {

    render() {
        const { notification, removeNotification } = this.props
        const listItems = renderNotificationList(notification.notifications, removeNotification)
        return (
            <div>{listItems}</div>
        )
    }
}

export default NotificationList;


// WEBPACK FOOTER //
// src/routes/notification/components/NotificationList.js